import { Text, Box, rem } from '@mantine/core';
import { TbX, TbCheck } from 'react-icons/tb';

type PasswordRequirementProps = {
  label: string;
  passes: boolean;
};

export default function PasswordRequirement({
  label,
  passes,
}: PasswordRequirementProps) {
  return (
    <Text
      c={passes ? 'green' : 'red'}
      style={{ display: 'flex', alignItems: 'center' }}
      mt={7}
      size="sm"
    >
      {passes ? (
        <TbCheck style={{ width: rem(14), height: rem(14) }} />
      ) : (
        <TbX style={{ width: rem(14), height: rem(14) }} />
      )}{' '}
      <Box ml={10}>{label}</Box>
    </Text>
  );
}
